// TODO
// возможно, нужно зарефакторить добавление в корзину товара и поискать варианты, чтобы
// избавиться от использования глобальной переменной isGlobalReceivedResponseChangeBasked
// Сейчас нужна для блокирования кнопок при действиях с корзиной

(function () {
    const isDev = globDev;

    // --- Моки ---
    const mockUrlBasketChange = "/ajaxurl/basketchange";
    const mockUrlBasketClean = "/ajaxurl/basketclean";

    let mockCounter = 0;

    $.mockjax ({
        url: mockUrlBasketChange,
        response: function (settings) {

            let result;

            if ($ ('.js-book-page').length < 0) {
                result = {
                    success: (JSON.parse (settings.data).q == 9),
                    errors: {
                        0: [
                            {
                                code: 'SALE_BASKET_AVAILABLE_QUANTITY',
                                customData: null,
                                message: 'В корзину уже добавлено максимальное количество товара "Пярт не может прыгнуть сальто" : 2'
                            }
                        ]
                    },
                    warnings: {
                        1: [
                            {
                                code: '',
                                customData: null,
                                message: 'Это ворнинг'
                            }
                        ]
                    },
                    items: [
                        {id: 100500, offerId: 34576, quantity: 1, price: 240, canBuy: 'Y'},
                        {id: 2, offerId: 2, quantity: 3, price: 420, priceOld: 480, canBuy: 'Y'},
                        {id: 3, offerId: 1, quantity: 3, price: 740, canBuy: 'Y'}
                    ],
                    summary: {
                        count: {val: Math.floor (Math.random () * (10) + 1)},
                        weight: {val: Number ((Math.random () * (10) + 0.1).toFixed (1))},
                        sumRaw: {val: Math.floor (Math.random () * (10000) + 1)},
                        sumDiscount: {val: Math.floor (Math.random () * (1000) + 1)},
                        sumFinal: {val: Math.floor (Math.random () * (15000) + 1)},
                        message: "Добавьте товаров на 5000 руб. и получите скидку 10% на ВЕСЬ заказ."
                    },
                    evData: {
                        price: 700
                    }
                };
            } else {
                result = {
                    success: true,
                    evData: {
                        price: 750
                    },
                    summary: {
                        countToOrder: {val: Math.floor (Math.random () * (10) + 1)},
                        count: {val: Math.floor (Math.random () * (10) + 1)},
                        weight: {val: Number ((Math.random () * (10) + 0.1).toFixed (1))},
                        sumRaw: {val: Math.floor (Math.random () * (10000) + 1)},
                        sumDiscount: {val: Math.floor (Math.random () * (1000) + 1)},
                        sumFinal: {val: Math.floor (Math.random () * (15000) + 1)},
                        message: "Добавьте товаров на 5000 руб. и получите скидку 10% на ВЕСЬ заказ.",
                        canOrder: true
                    },
                    list: {
                        list: "Тестовый список",
                        position: 1
                    },
                    items: [
                        {id: 100500, offerId: 34576, quantity: 1, price: 240, canBuy: 'Y'},
                        {id: 2, offerId: 2, quantity: 3, price: 420, priceOld: 480, canBuy: 'Y'},
                        {id: 3, offerId: 1, quantity: 3, price: 740, canBuy: 'Y'}
                    ]
                };

                const changingId = 2;
                if (mockCounter === 1) {
                    const $changingItem = $ ('.js-basket-page .js-basket-item[data-item-offer-id="'+changingId+'"]');
                    const $changingQ = $changingItem.attr ('data-available-quantity');
                    $changingItem.attr ('data-available-quantity', $changingQ - 2);
                }

                $ ('.js-basket-page .js-basket-item').each ((i, item) => {
                    const $thisItem = $ (item);
                    const name = $thisItem.data ('item-name');
                    const bookId = $thisItem.data ('item-id');
                    const offerId = $thisItem.data ('item-offer-id');
                    let quantity = $thisItem.find ('.js-btn-buy-quantity input').val ();
                    const price = $thisItem.find ('.js-basket-item-price-one').html ().replace (/\D/g, '');
                    const dataObj = JSON.parse(settings.data);
                    const availableQuantity = $thisItem.attr ('data-available-quantity');

                    const flagActiveItem = (''+offerId === ''+dataObj.offerId);

                    if (flagActiveItem) {
                        quantity = dataObj.q;
                    }

                    if (availableQuantity < quantity) {
                        if (flagActiveItem) {
                            result.success = false;
                            result.errors = {};
                            result.errors[offerId] = [
                                {
                                    code: 'SALE_BASKET_AVAILABLE_QUANTITY',
                                    customData: null,
                                    message: 'В корзину уже добавлено максимальное количество товара "'+name+'" : '+availableQuantity
                                }
                            ];
                        }
                        quantity = availableQuantity;
                    }

                    if (quantity > 0) {
                        result.items.push({
                            id: bookId,
                            offerId: offerId,
                            quantity: quantity,
                            price: price,
                            availableQuantity: availableQuantity
                        });
                    }
                });

                result.gifts = {
                    "ajaxUrlChoose": '#',
                    "items": [
                        {
                            "id": 1,
                            "offerId": 0,
                            "link": "#",
                            "isFavourite": true,
                            "bookTitle": "Мой продуктивный год",
                            "bookSubtitle": "Как я проверил самые известные методики самые известные методики",
                            "bookLink": "#",
                            "bookType": "Твердый переплет",
                            "bookCategory": "Саморазвитие",
                            "price": 1090,
                            "priceOld": 1200,
                            "quantity": 1,
                            "publisher": "Альпина Паблишер",
                            "isAutoAdded": true,
                        },
                        {
                            "id": 1,
                            "offerId": 0,
                            "link": "#",
                            "isFavourite": true,
                            "bookTitle": "Мой продуктивный год",
                            "bookSubtitle": "Как я проверил самые известные методики самые известные методики",
                            "bookLink": "#",
                            "bookType": "Твердый переплет",
                            "bookCategory": "Саморазвитие",
                            "price": 1090,
                            "priceOld": 1200,
                            "quantity": 1,
                            "publisher": "Альпина Паблишер",
                            "img": {
                                "x1": "assets/img/media/basket/mitio.jpg",
                                "x2": "assets/img/media/basket/mitio@2x.jpg",
                                "x3": "assets/img/media/basket/mitio@3x.jpg"
                            },
                        }
                    ],
                    "blocks": [
                        {
                            "text": "Бесплатно добавьте в корзину одну книгу в качестве подарка от нашего магазина за покупку от 5000&nbsp;рублей.",
                            "itemsChoice": [
                                {
                                    "id": 1,
                                    "offerId": 0,
                                    "bookTitle": "Мой продуктивный год",
                                    "bookType": "Твердый переплет"
                                },
                                {
                                    "id": 3,
                                    "offerId": 1,
                                    "bookTitle": "Будущее разума",
                                    "bookType": "Мягкая обложка",
                                    "img": {
                                        "x1": "assets/img/media/basket/mitio.jpg",
                                        "x2": "assets/img/media/basket/mitio@2x.jpg",
                                        "x3": "assets/img/media/basket/mitio@3x.jpg"
                                    }
                                },
                                {
                                    "id": 1,
                                    "offerId": 0,
                                    "bookTitle": "Мой продуктивный год",
                                    "bookType": "Твердый переплет"
                                },
                                {
                                    "id": 3,
                                    "offerId": 1,
                                    "bookTitle": "Будущее разума",
                                    "bookType": "Мягкая обложка",
                                    "img": {
                                        "x1": "assets/img/media/basket/mitio.jpg",
                                        "x2": "assets/img/media/basket/mitio@2x.jpg",
                                        "x3": "assets/img/media/basket/mitio@3x.jpg"
                                    }
                                }
                            ]
                        },
                        {
                            "text": "Бесплатно добавьте в корзину одну книгу в качестве подарка от нашего магазина за покупку от 7000&nbsp;рублей.",
                            "itemsChoice": [
                                {
                                    "id": 1,
                                    "offerId": 0,
                                    "bookTitle": "Мой продуктивный год",
                                    "bookType": "Твердый переплет"
                                },
                                {
                                    "id": 3,
                                    "offerId": 1,
                                    "bookTitle": "Будущее разума",
                                    "bookType": "Мягкая обложка"
                                },
                                {
                                    "id": 1,
                                    "offerId": 0,
                                    "bookTitle": "Мой продуктивный год",
                                    "bookType": "Твердый переплет"
                                },
                                {
                                    "id": 3,
                                    "offerId": 1,
                                    "bookTitle": "Будущее разума",
                                    "bookLink": "#",
                                    "bookType": "Мягкая обложка",
                                    "img": {
                                        "x1": "assets/img/media/basket/mitio.jpg",
                                        "x2": "assets/img/media/basket/mitio@2x.jpg",
                                        "x3": "assets/img/media/basket/mitio@3x.jpg"
                                    }
                                }
                            ]
                        }
                    ]
                };
            }

            mockCounter++;
            this.responseText = result;
        }
    });

    $.mockjax ({
        url: mockUrlBasketClean,
        responseText: {
            success: true,
            message: "Добавьте товаров на 2000 руб. и получите БЕСПЛАТНУЮ доставку по России."
        }
    });

    $ (function () {
        globalApp.basket = {
            itemChange: function (bookId, offerId, q, getBasket = true, itemData = {}, listData = false, callback = function (responseData) {}) {
                if (isGlobalReceivedResponseChangeBasked && isGlobalNoBasketTimeout) {
                    isGlobalReceivedResponseChangeBasked = false;
                    $ ('body').addClass ('globalDisable');
                    $ (document).trigger ("showPreloader").trigger('basket-response-start');

                    let ajaxUrl = (!isDev) ? globalData.ajaxUrls.basketAction : mockUrlBasketChange;
                    let ajaxData = {bookId: bookId, offerId: offerId, q: q, getBasket: getBasket};
                    if (typeof (listData) === "object" && listData.list !== false && listData.list !== undefined && listData.list !== "") {
                        ajaxData.list = listData;
                    }
                    if (typeof (itemData) === 'object' && itemData.basketType === 'digital') {
                        ajaxData.basketType = 'digital'
                    }

                    if (ajaxUrl) {
                        const promise = $.ajax ({
                            method: 'POST',
                            url: ajaxUrl,
                            data: JSON.stringify (ajaxData),
                            dataType: 'json'
                        });

                        promise
                            .done (function (response) {
                                $ (document).trigger ('basket-response-end')
                                if (response.success === true) {

                                    // TODO прочекать это

                                    // Управляем состоянием прелоадера в боковой корзине
                                    // Если товар добавляется в первый раз, то прелоадер
                                    // удалится после добавления товара в боковую корзину (то есть, не в коде ниже)
                                    const $activeBasketItem = $ (".js-modal-basket-container .js-basket-item[data-item-id=\"" + bookId + "\"][data-item-offer-id=\"" + offerId + "\"]");
                                    if ($activeBasketItem.length !== 0) {
                                        isGlobalReceivedResponseChangeBasked = true;
                                        $ ('body').removeClass ('globalDisable');
                                        $ (document).trigger ("hidePreloader");
                                    }

                                    // триггерим общее событие изменения корзины
                                    $ (document).trigger ("basketItemChange", [bookId, offerId, q, response]);

                                    // триггерим событие аналитики
                                    const evData = {
                                        item: Object.assign ({price: globalFunctions.escapeStr (response.evData.price)}, itemData),
                                        items: []
                                    };
                                    if (response.list) {
                                        evData.item.list = globalFunctions.escapeStr (response.list.list);
                                        evData.item.position = globalFunctions.escapeStr (response.list.position);
                                    }
                                    $.each (response.items, function (i, item) {
                                        evData.items.push ({
                                            bookId: globalFunctions.escapeStr (item.id),
                                            offerId: globalFunctions.escapeStr (item.offerId),
                                            quantity: globalFunctions.escapeStr (item.quantity),
                                            price: globalFunctions.escapeStr (item.price)
                                        });
                                    });
                                    $ (document).trigger ("eventBasketChange", [evData]);

                                    // todo избавиться от костыля
                                    // перезагрузка корзины при добавлении из рекомендаций
                                    if (isGlobalBasketRefresh) {
                                        document.location.reload();
                                    }
                                    // удаление прелоадера после добавления товара
                                    isGlobalBasketRefresh = false;
                                    isGlobalReceivedResponseChangeBasked = true;
                                    $ ('body').removeClass ('globalDisable');
                                    $ (document).trigger ("hidePreloader");

                                    callback (response);

                                } else {
                                    isGlobalReceivedResponseChangeBasked = true;
                                    isGlobalBasketRefresh = false;
                                    $ ('body').removeClass ('globalDisable');
                                    $ (document).trigger ("hidePreloader");

                                    if (response.errors) {
                                        let text = '';
                                        let isQuantityExceeded = false;
                                        $.each (response.errors, (id, errors) => {
                                            $.each (errors, (i, messageObject) => {
                                                text += messageObject.message + '<br><br>';
                                                if (messageObject.code === 'SALE_BASKET_AVAILABLE_QUANTITY') {
                                                    isQuantityExceeded = true;
                                                }
                                            });
                                        });
                                        text = text || 'Произошла ошибка, попробуйте позднее.';
                                        $ (document).trigger ('is:errorModal', {title: ' ', text: text});
                                        
                                        if (isQuantityExceeded) {
                                            const quantityErrorEvent = new CustomEvent('basket.quantity.exceeded', {
                                                detail: {
                                                    response: response,
                                                    offerId: offerId
                                                }
                                            });
                                            document.dispatchEvent(quantityErrorEvent);
                                        }
                                    }

                                    return false;
                                }
                            })
                            .fail (function (jqXHR, textStatus, errorThrown) {
                                isGlobalReceivedResponseChangeBasked = true;
                                isGlobalBasketRefresh = false;
                                $ ('body').removeClass ('globalDisable');
                                $ (document).trigger ("hidePreloader").trigger ('basket-response-end')

                                $ (document).trigger ('is:errorModal', {title: ' ', text: 'Произошла ошибка, попробуйте позднее.'});
                                return false;
                            });
                    }
                }
            },
            clean: function (callback = function (responseData) {
            }) {
                let ajaxUrl = (!isDev) ? globalData.ajaxUrls.basketClean : mockUrlBasketClean;
                if (ajaxUrl) {
                    const promise = $.ajax ({
                        method: 'POST',
                        url: ajaxUrl,
                        dataType: 'json'
                    });

                    promise
                        .done (function (response) {
                            isGlobalReceivedResponseChangeBasked = true;
                            if (response.success) {
                                $ (document).trigger ("basketClean");
                                callback (response);
                            } else {
                                $ (document).trigger ('is:errorModal', {title: "Произошла ошибка!", text: ""});
                            }
                        })
                        .fail (function () {
                            isGlobalReceivedResponseChangeBasked = true;
                            $ (document).trigger ('is:errorModal', {title: "Произошла ошибка!", text: ""});
                        });
                }
            },

            // вызывать эту функцию только после
            // if (isGlobalReceivedResponseChangeBasked && isGlobalNoBasketTimeout)
            // в обработчике promise из этой функции обязательно нужно вызывать код
            // isGlobalReceivedResponseChangeBasked = true;
            // globalApp.basket.loader (false);

            productChange: (productData) => {
                isGlobalReceivedResponseChangeBasked = false;
                globalApp.basket.loader (true);

                return $.ajax ({
                    method: 'POST',
                    url: (!isDev) ? globalData.ajaxUrls.basketAction : mockUrlBasketChange,
                    data: JSON.stringify (productData),
                    dataType: 'json'
                });
            },

            loader: (show = true) => {
                if (show) {
                    $ ('body').addClass ('globalDisable');
                    $ (document).trigger ('showPreloader');
                } else {
                    $ ('body').removeClass ('globalDisable');
                    $ (document).trigger ('hidePreloader');
                }
            }
        }
    })
} ());
